// Shared "🔗 Share" button behaviour for the pages that have one.
// Provides a `linkCopied` flag and `copyShareLink(url)` — writes the URL (defaulting
// to the current address) to the clipboard and flashes `linkCopied` for 1.5s.
// Components keep their own thin `copyLink()` when they build a custom URL.
export default {
  data() {
    return { linkCopied: false };
  },
  methods: {
    copyShareLink(url) {
      const target = url || window.location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(target).then(() => {
          this.linkCopied = true;
          setTimeout(() => { this.linkCopied = false; }, 1500);
        }).catch(() => {});
      }
    },
  },
};
